import Vue from 'vue'
import Router from 'vue-router'
import Main from './pages/main.vue';
import Mmain from './pages/m/m-main.vue';
Vue.use(Router);


const router = new Router({
    mode:'history',
    // base: process.env.NODE_ENV,
    // base: process.env.NODE_ENV === 'production' ? '/production' : '', // 动态设置前缀
    routes: [
        {
            path: '/',
            name: 'index',
            component: Main,
            redirect: '/index',
            meta: {
                title: '博努力（北京）仿真技术有限公司'
            },
            children: [
                { 
                    path: '/',
                    name: 'index',
                    component: () => import('./pages/index.vue'),
                    meta: {
                        title: '博努力（北京）仿真技术有限公司'
                    }
                },
                { 
                    path: '/about',
                    name: 'about',
                    redirect: '/aboutchild',
                    component: () => import('./pages/about.vue'),
                    meta: {
                        title: '关于我们-博努力（北京）仿真技术有限公司'
                    },
                    children: [
                        { 
                            path: '/aboutchild',
                            name: 'aboutchild',
                            component: () => import('./pages/about/aboutchild.vue'),
                            meta: {
                                title: '关于我们-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/culture',
                            name: 'culture',
                            component: () => import('./pages/about/culture.vue'),
                            meta: {
                                title: '企业文化-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/glory',
                            name: 'glory',
                            component: () => import('./pages/about/glory.vue'),
                            meta: {
                                title: '企业荣誉-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/partner',
                            name: 'partner',
                            component: () => import('./pages/about/partner.vue'),
                            meta: {
                                title: '合作伙伴-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/qualifications',
                            name: 'qualifications',
                            component: () => import('./pages/about/qualifications.vue'),
                            meta: {
                                title: '公司资质-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/recruit',
                            name: 'recruit',
                            component: () => import('./pages/about/recruit.vue'),
                            meta: {
                                title: '招聘信息-博努力（北京）仿真技术有限公司'
                            }
                        }
                    ]
                },
                {
                    path: '/certificate',
                    name: 'certificate',
                    redirect: '/baseFoundation',
                    component: () => import('./pages/certificate.vue'),
                    meta: {
                        title: '评价基地-博努力（北京）仿真技术有限公司'
                    },
                    children: [
                        { 
                            path: '/baseFoundation',
                            name: 'baseFoundation',
                            component: () => import('./pages/certificate/baseFoundation.vue'),
                            meta: {
                                title: '基地基础-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/evalStandard',
                            name: 'evalStandard',
                            component: () => import('./pages/certificate/evalStandard.vue'),
                            meta: {
                                title: '评价标准-博努力（北京）仿真技术有限公司',
                                keepAlive: true
                            }
                        },
                        { 
                            path: '/evalSystem',
                            name: 'evalSystem',
                            component: () => import('./pages/certificate/evalSystem.vue'),
                            meta: {
                                title: '评价制度-博努力（北京）仿真技术有限公司',
                                keepAlive: true
                            }
                        },
                        { 
                            path: '/trainResource',
                            name: 'trainResource',
                            component: () => import('./pages/certificate/trainResource.vue'),
                            meta: {
                                title: '培训资源-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/certIntro',
                            name: 'certIntro',
                            component: () => import('./pages/certificate/certIntro.vue'),
                            meta: {
                                title: '证书介绍及报考-博努力（北京）仿真技术有限公司'
                            }
                        }
                    ]
                },
                { 
                    path: '/product',
                    name: 'product',
                    component: () => import('./pages/product.vue'),
                    meta: {
                        title: '仿真产品-博努力（北京）仿真技术有限公司'
                    },
                },
                { 
                    path: '/solution',
                    name: 'solution',
                    component: () => import('./pages/solution.vue'),
                    meta: {
                        title: '解决方案-博努力（北京）仿真技术有限公司'
                    }
                },
                { 
                    path: '/simulation',
                    name: 'simulation',
                    component: () => import('./pages/simulation.vue'),
                    meta: {
                        title: '仿真软件-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/download',
                    name: 'download',
                    component: () => import('./pages/download.vue'),
                    meta: {
                        title: '下载-博努力（北京）仿真技术有限公司'
                    }
                },
                { 
                    path: '/synergy',
                    name: 'synergy',
                    component: () => import('./pages/synergy.vue'),
                    meta: {
                        title: '协同育人-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/active',
                    name: 'active',
                    component: () => import('./pages/active.vue'),
                    meta: {
                        title: '公司动态-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/solution-active',
                    name: 'solutionActive',
                    component: () => import('./pages/solution-active.vue'),
                    meta: {
                        title: '解决方案-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/certificate',
                    name: 'certificate',
                    component: () => import('./pages/certificate.vue'),
                    meta: {
                        title: '评价基地-博努力（北京）仿真技术有限公司'
                    }
                },
                {
					path: '/certificate-active',
					name: 'certificateActive',
					component: () => import('./pages/certificate-active.vue'),
					meta: {
					    title: '评价基地-博努力（北京）仿真技术有限公司'
					},
				},
                {
					path: '/synergy-active',
					name: 'synergyActive',
					component: () => import('./pages/synergy-active.vue'),
					meta: {
					    title: '协同育人-博努力（北京）仿真技术有限公司'
					},
				},
                {
                    path: '/downloads',
                    name: 'downloads',
                    component: () => import('./pages/download2.vue'),
                    meta: {
                        title: '垃圾焚烧发电运行与维护仿真系统-博努力（北京）仿真技术有限公司'
                    }
                },
				{
                    path: '/downloads1',
                    name: 'downloads1',
                    component: () => import('./pages/download3.vue'),
                    meta: {
                        title: '发电集控运行与维护仿真系统-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/video',
                    name: 'video',
                    component: () => import('./pages/video.vue'),
                    meta: {
                        title: '"1+X"试点工作线上说明会-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/learn',
                    name: 'learn',
                    component: () => import('./pages/learn/learn.vue'),
                    meta: {
                        title: 'Learning'
                    }
                },
				{
				    path: '/learn2',
				    name: 'learn2',
				    component: () => import('./pages/learn/learn2.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},{
				    path: '/learn3',
				    name: 'learn3',
				    component: () => import('./pages/learn/learn3.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn4',
				    name: 'learn4',
				    component: () => import('./pages/learn/learn4.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn5',
				    name: 'learn5',
				    component: () => import('./pages/learn/learn5.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn6',
				    name: 'learn6',
				    component: () => import('./pages/learn/learn6.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn7',
				    name: 'learn7',
				    component: () => import('./pages/learn/learn7.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn8',
				    name: 'learn8',
				    component: () => import('./pages/learn/learn8.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn9',
				    name: 'learn9',
				    component: () => import('./pages/learn/learn9.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn10',
				    name: 'learn10',
				    component: () => import('./pages/learn/learn10.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
				    path: '/learn11',
				    name: 'learn11',
				    component: () => import('./pages/learn/learn11.vue'),
				    meta: {
				        title: 'Learning'
				    }
				},
                {
                    path: '/materials',
                    name: 'materials',
                    component: () => import('./pages/materials.vue'),
                    meta: {
                        title: '1+X教材配套资料'
                    }
                }
            ]
        },
        {
            path: '/m',
            name: 'm',
            component: Mmain,
            redirect: '/mhome',
            meta: {
                title: '博努力（北京）仿真技术有限公司'
            },
            children: [
                { 
                    path: '/mhome',
                    name: 'mhome',
                    component: () => import('./pages/m/m-home.vue'),
                    meta: {
                        title: '博努力（北京）仿真技术有限公司'
                    }
                },
                { 
                    path: '/mdownload',
                    name: 'mdownload',
                    component: () => import('./pages/m/m-download.vue'),
                    meta: {
                        title: '下载博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/mproduct',
                    name: 'mproduct',
                    component: () => import('./pages/m/m-product.vue'),
                    meta: {
                        title: '仿真产品-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/mpdetail',
                    name: 'mpdetail',
                    component: () => import('./pages/m/m-product-detail.vue'),
                    meta: {
                        title: '仿真产品-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/msimulation',
                    name: 'msimulation',
                    component: () => import('./pages/m/m-simulation.vue'),
                    meta: {
                        title: '仿真软件-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/msdetail',
                    name: 'msdetail',
                    component: () => import('./pages/m/m-simulation-detail.vue'),
                    meta: {
                        title: '仿真软件-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/msolution',
                    name: 'msolution',
                    component: () => import('./pages/m/m-solution.vue'),
                    meta: {
                        title: '解决方案-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/mssdetail',
                    name: 'mssdetail',
                    component: () => import('./pages/m/m-solution-detail.vue'),
                    meta: {
                        title: '解决方案-博努力（北京）仿真技术有限公司'
                    }
                },
                {
                    path: '/mactive',
                    name: 'mactive',
                    component: () => import('./pages/m/m-active.vue'),
                    meta: {
                        title: '解决方案-博努力（北京）仿真技术有限公司'
                    }
                },
				{ 
				    path: '/mmaterials',
				    name: 'mmaterials',
				    component: () => import('./pages/m/m-materials.vue'),
				    meta: {
				        title: '1+X教材配套资料'
				    }
				},
                {
                    path: '/mabout',
                    name: 'mabout',
                    component: () => import('./pages/m/m-about.vue'),
                    meta: {
                        title: '关于我们-博努力（北京）仿真技术有限公司'
                    },
                    children: [
                        { 
                            path: '/maboutchild',
                            name: 'maboutchild',
                            component: () => import('./pages/m/mabout/maboutchild.vue'),
                            meta: {
                                title: '关于我们-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/mculture',
                            name: 'mculture',
                            component: () => import('./pages/m/mabout/mculture.vue'),
                            meta: {
                                title: '企业文化-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/mglory',
                            name: 'mglory',
                            component: () => import('./pages/m/mabout/mglory.vue'),
                            meta: {
                                title: '企业荣誉-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/mpartner',
                            name: 'mpartner',
                            component: () => import('./pages/m/mabout/mpartner.vue'),
                            meta: {
                                title: '合作伙伴-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/mqualifications',
                            name: 'mqualifications',
                            component: () => import('./pages/m/mabout/mqualifications.vue'),
                            meta: {
                                title: '公司资质-博努力（北京）仿真技术有限公司'
                            }
                        },
                        { 
                            path: '/mrecruit',
                            name: 'mrecruit',
                            component: () => import('./pages/m/mabout/mrecruit.vue'),
                            meta: {
                                title: '招聘信息-博努力（北京）仿真技术有限公司'
                            }
                        }
                    ]
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    // console.log(to);
    // next({
    //     name: 'home' // 跳转到home页
    // })
    next()
})
export default router